import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { colors } from '../../../../constants'
import { Column, Button, Headings } from '../../..'
import { withSize } from '../../../utils'

interface InlineProps {
    show?: boolean
    animation?: boolean
}

export const Inline = styled.div<InlineProps>`
    width: auto;
    display: inline-block;
    vertical-align: middle;

    @keyframes expan {
        0% {
            width: 0;
            transform: scaleX(0);
        }
        1% {
            width: auto;
        }
        10% {
            width: auto;
            transform: scaleX(1);
        }
    }

    @keyframes collapse {
        0% {
            width: auto;
            transform: scaleX(1);
        }
        99% {
            width: auto;
        }
        100% {
            width: 0;
            transform: scaleX(0);
        }
    }

    ${({ show = false, animation = false }) => {
        if (!animation) {
            return ''
        }

        if (show) {
            return `
        animation-name: collapse;
        animation-duration: 0.3s;
      `
        }

        return `
      animation-name: collapse;
      animation-duration: 0.3s;
    `
    }}
`

const Title = styled.div`
    align-items: center;
    background: ${colors.greylightest};
    display: flex;
    padding: 15px 30px 0;

    flex-direction: ${({ isMobile }: { isMobile: boolean }) => (isMobile ? 'column' : 'row')};
`

interface LayersListTitleProps {
    children: JSX.Element
    onClickUpload: () => void
    isMobile: boolean
    onClickDelete: () => void
}

function LayersListTitle(props: LayersListTitleProps) {
    const { children = null, isMobile = false, onClickUpload, onClickDelete } = props

    const { t } = useTranslation()

    return (
        <Title isMobile={isMobile}>
            <Column width={isMobile ? '100%' : '50%'}>
                <Headings.H2 inline capitalized bold>
                    {t('Layers')}
                </Headings.H2>
            </Column>
            <Column width={isMobile ? '100%' : '50%'} right={!isMobile} padding="10px">
                <Inline>
                    <Button icon="trash-alt" theme="danger" onClick={onClickDelete}>
                        Delete
                    </Button>
                    <Button icon="file-upload" onClick={onClickUpload}>
                        Upload
                    </Button>
                    {children}
                </Inline>
            </Column>
        </Title>
    )
}

export default withSize(LayersListTitle)
